export const GET_DATA_ACTION_LOG = 'GET_DATA_ACTION_LOG';
export const FILTER_ACTION_LOG = 'FILTER_ACTION_LOG';
export const LOAD_ACTION_BY_FILTER = 'LOAD_ACTION_BY_FILTER';